export const LINK_TYPE_HREF = {
  PHONE: 'tel:',
  MAIL: 'mailto:',
};
